import type { FC } from 'react';
import type { AccordionSetProps } from 'src/components/CookieSettings/AccordionSet/types';
import { IntroAccordion } from 'src/components/CookieSettings/IntroAccordion';
import { EssentialAccordion } from 'src/components/CookieSettings/EssentialAccordion';
import { SaleOfInfoAccordion } from 'src/components/CookieSettings/SaleOfInfoAccordion';
import { AnalyticsAccordion } from 'src/components/CookieSettings/AnalyticsAccordion';
import { FunctionalAccordion } from 'src/components/CookieSettings/FunctionalAccordion';

export const AccordionSet: FC<AccordionSetProps> = ({ dispatch, state }: AccordionSetProps) => {
    const locale = state.selectedLanguage;
    const isCanadian = locale === 'en-CA' || locale === 'fr-CA';

    return (
        <>
            <IntroAccordion />
            <EssentialAccordion state={state} />
            {isCanadian && <AnalyticsAccordion state={state} dispatch={dispatch} />}
            {isCanadian && <FunctionalAccordion dispatch={dispatch} state={state} />}
            <SaleOfInfoAccordion dispatch={dispatch} state={state} />
        </>
    );
};
